<template>
  <v-layout row align-end justify-space-between class="pa-3 footer">
    <v-flex class="footer-container hidden-xs-only">
      <div>&nbsp;</div>
    </v-flex>
    <v-flex class="text-xs-center" style="flex-grow: 4!important;">
      <ul class="social" text-xs-center>
        <li>
          <a target="_blank" href="https://www.linkedin.com/in/taras-semenyuk-05b48965/" aria-label="linkedin profile" rel="noopener">
            <font-awesome-icon aria-hidden title="linkedin profile" :icon="['fab', 'linkedin']" :size="iconSize" transform="grow-4" style="color: #0077B5; background: #fff;" />
          </a>
        </li>
        <li>
          <a target="_blank" href="https://github.com/styfrombrest" aria-label="github profile" rel="noopener">
            <font-awesome-icon aria-hidden title="github profile" :icon="['fab', 'github']" :size="iconSize" /> </a>
        </li>
        <li>
          <a target="_blank" href="https://www.instagram.com/sty_from_brest/" aria-label="instagram profile" rel="noopener">
            <font-awesome-icon aria-hidden title="github profile" :icon="['fab', 'instagram']" :size="iconSize" /> </a>
        </li>
<!--        <li>-->
<!--          <a target="_blank" href="https://twitter.com/STY_from_Brest" aria-label="twitter profile" rel="noopener">-->
<!--            <font-awesome-icon aria-hidden title="twitter profile" :icon="['fab', 'twitter']" :size="iconSize" style="color: #00aced" />-->
<!--          </a>-->
<!--        </li>-->
      </ul>
    </v-flex>
    <v-flex class="footer-container text-xs-right">
      <div class="grey--text darken-3 ">
        © Taras Semenyuk 2018 - {{ new Date().getFullYear() }}
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';

export default {
  name: 'FooterBar',
  components: {
    FontAwesomeIcon,
  },
  computed: {
    iconSize() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return '1x';
        default:
          return '2x';
      }
    },
  },
};
</script>

<style scoped>
.footer-container {
  flex-grow: 0 !important;
  flex-basis: 200px !important;
}

.footer {
  background-color: rgba(0, 0, 0, 0) !important;
  flex: 0.1;
}

.social {
  list-style-type: none;
  display: block;
}

.social li {
  display: inline-block;
  opacity: 0.6;
  transition: all 0.3s ease-in-out;
  margin-right: 16px;
}

.social li:last-child {
  margin-right: 0;
}

.social li:hover {
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/FooterBar.vue